import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenericEvent } from '../models/event.model';

@Injectable({
  providedIn: 'root'
})
export class CurrentEventService {
  private eventSubject = new BehaviorSubject<GenericEvent | null>(null);
  event$: Observable<GenericEvent | null> = this.eventSubject.asObservable();

  get event(): GenericEvent | null {
    return this.eventSubject.value;
  }

  set(event: GenericEvent) {
    this.eventSubject.next(event);
  }

  clear() {
    this.eventSubject.next(null);
  }
}
